module.exports = __webpack_public_path__ + "img/facial_hair_chin_mustache_thick_average_mask.6c04d5a4.png";